import { useEffect } from 'react';
import { useIntegrationsStore } from '../../../stores/use-integrations-store';
import { GIS_ZHKH_KEY } from './constants';
import { clearGisPaymentPending, getGisPaymentPendingDeviceId } from './subscribeGisZhkkh';

const POLL_INTERVAL_MS = 2500;
const POLL_TIMEOUT_MS = 60000;

function findGisStatus(rows, deviceId) {
  for (const object of rows || []) {
    for (const device of object?.devices_integrations_info || []) {
      if (String(device?.device_id) !== String(deviceId)) continue;
      const gis = (device?.integrations || []).find((item) => item.key === GIS_ZHKH_KEY);
      if (gis) return gis.status;
    }
  }
  return null;
}

/** After YooKassa return, poll until gis_zhkkh becomes active. */
export function useGisZhkkhPaymentPolling() {
  const fetchIntegrations = useIntegrationsStore((state) => state.fetchIntegrations);

  useEffect(() => {
    const pendingDeviceId = getGisPaymentPendingDeviceId();
    if (!pendingDeviceId) return undefined;

    const startedAt = Date.now();
    let cancelled = false;
    let timerId;

    const poll = async () => {
      if (cancelled) return;
      await fetchIntegrations();
      const status = findGisStatus(useIntegrationsStore.getState().integrations, pendingDeviceId);

      if (status === 'active' || Date.now() - startedAt >= POLL_TIMEOUT_MS) {
        clearGisPaymentPending();
        return;
      }

      timerId = setTimeout(poll, POLL_INTERVAL_MS);
    };

    poll();

    return () => {
      cancelled = true;
      if (timerId) clearTimeout(timerId);
    };
  }, [fetchIntegrations]);
}
